import * as Yup from "yup";

export const validationSchema = (showIsHead) =>
  Yup.object().shape({
    first_name: Yup.string().required("First name is required!"),
    middle_name: Yup.string().required("Middle name is required!"),
    aadhar_no: Yup.string()
      .nullable()
      .test("aadhar-validation", "Aadhaar Number must be 12 digits!", function (value) {
        if (showIsHead) {
          if (!value) {
            return this.createError({
              message: "Aadhaar Number is required!",
            });
          }
          return /^[0-9]{12}$/.test(value);
        }

        if (value && value.trim() !== "") {
          return /^[0-9]{12}$/.test(value);
        }
        return true;
      }),
    surname: Yup.string().required("Surname is required!"),
    maternal_surname: Yup.string().nullable(),
    gender: Yup.string().nullable(),
    birth_date: Yup.date().nullable().required("Date of birth is required!"),
    marital_status: Yup.string().nullable(),
    blood_group: Yup.string().nullable(),
    mobile_number: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits!")
      .required("Mobile number is required!"),
    education_id: Yup.string().nullable(),
    general_occupation_id: Yup.string().nullable(),
    occupation_details: Yup.string().nullable(),
    current_address: Yup.string().nullable(),
    current_district_id: Yup.string().nullable(),
    current_taluka_id: Yup.string().nullable(),
    current_village_id: Yup.string().nullable(),
    other_village_name: Yup.string().when("current_village_id", {
      is: "other",
      then: (schema) => schema.required("Other village name is required!"),
      otherwise: (schema) => schema.nullable(),
    }),
    native_district: Yup.string().nullable(),
    native_taluka: Yup.string().nullable(),
    native_village: Yup.string().nullable(),
    other_native_village_name: Yup.string().when("native_village", {
      is: "Other",
      then: (schema) => schema.required("Other native village name is required!"),
      otherwise: (schema) => schema.nullable(),
    }),
    member_number: showIsHead ? Yup.string().required("Member Number is required!") : "",
    is_active: Yup.string().required("Status is required!"),
    parent_id: !showIsHead ? Yup.string().required("Head Member is required!") : "",
    relation: !showIsHead ? Yup.string().required("Relation with head of family is required!") : "",
    expire_verification: Yup.date().nullable(),
  });
